import { action } from "satcheljs";

export const onLoadTheme: () => {} = action("ON_LOAD_THEME", (): {} => ({}));
